import React from 'react';
import PropTypes from 'prop-types';
import { serializeClasses } from 'utilities/css';
import { IconContainer, Container } from './styled';

export const IconDecorator = (Component) => {
  const IconComponent = ({
    icon: Icon,
    iconPosition,
    className,
    ...rest
  }) => {
    if (!Icon) {
      return <Component {...rest} className={className} />;
    }

    const iconClasses = serializeClasses([
      'icon',
      iconPosition,
    ]);

    return (
      <Container className={className}>
        <IconContainer className={iconClasses}>
          {Icon}
        </IconContainer>
        <Component
          className={className}
          {...rest}
        />
      </Container>
    );
  };

  IconComponent.propTypes = {
    className: PropTypes.string,
    icon: PropTypes.node,
    iconPosition: PropTypes.oneOf(['left', 'right']),
  };

  IconComponent.defaultProps = {
    className: undefined,
    icon: null,
    iconPosition: 'left',
  };

  return IconComponent;
};

